import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "../../../comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

export const BASE = {
    path: `${ptlEnvs.base}/ewc/svr`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/ewc/notilogs`,
};

export const URLS = {
    ewci1001005q: `${BASE.path}/ewci1001005q`,
    ewci1001006q: `${BASE.path}/ewci1001006q`,
};

export const APIS = {
    //알림 목록 조회
    getNotiLogsList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        })
    }, 
    //알림 상세정보 조회
    getNotiLogsInfo: (notiSendUuid: any) => {
        return api.get(`${BASE.api}/${notiSendUuid}`);
    }
};

export const SF_NOTI_LOGS_SRCH: TFormSchema = {
    id: "form_notiLogsSrch",
    schema: {
        notiSendStatCd: { type: "select", label: "L_NOTI_SEND_STAT", area: "comnCd", comnCd: "PTL0022" },
        bsopClsfCd: { type: "select", label: "L_BSOP_CLSF_NM", area: "comnCd", comnCd: "COM0024", required: true },
        notiId : {type: "text", label : "L_NOTI_ID"},
        notiTpValue : {type: "select", label : "L_NOTI_TP", 
            options:
            [
                { label: "SMS", value: "1" },
                { label: "E-Mail", value: "2" },
                { label: "Push Notification", value: "4" },
            ]
        },
        srchDt: {
            label: "L_FRST_RGSR_DTM",
            type: "daterange",
            start: { name: "srchDtFrom", defaultValue: comnUtils.getDate({ m: -1 }) },
            end: { name: "srchDtTo", defaultValue: comnUtils.getDate() },
            rangeButton: 2,
        },

    },
};

export const SG_NOTI_LOGS_LIST: TGridSchema = {
    id: "grid_notiLogsList", 
    options: { pagination: "out", index: true, checkbox: false },

    head: [
        { cells: [{ header: "L_NOTI_ID", binding: "notiId", width: "*" }] },
        { cells: [{ header: "L_BSOP_CLSF_CD", binding: "bsopClsfCd", width: "*" }] },
        { cells: [{ header: "L_NOTI_NM", binding: "notiNm", width: "20%" }] },
        { cells: [{ header: "L_USR_NM", binding: "usrNm", width: "*" }] },
        { cells: [{ header: "L_USR_EML_ADDR", binding: "usrEmlAddr", width: "*" }] },
        { cells: [{ header: "L_USR_MOBL_NO", binding: "usrMoblNo", width: "*" }] },
        { cells: [{ header: "L_NOTI_TP", binding: "notiTpValue", width: "*" }] },
        { cells: [{ header: "L_NOTI_SEND_STAT", binding: "notiSendStatNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "notiId" }] },
        { cells: [{ binding: "bsopClsfCd" }] },
        { cells: [{ binding: "notiNm" }] },
        { cells: [{ binding: "usrNm" }] },
        { cells: [{ binding: "usrEmlAddr" }] },
        { cells: [{ binding: "usrMoblNo" }] },
        { cells: [{ binding: "notiTpValue" }] },
        { cells: [{ binding: "notiSendStatNm" }] },
    ],
}

export const SF_NOTI_LOGS_INFO: TFormSchema = {
    id: "form_notiLogsInfo",
    schema: {
        bsopClsfCd: { type: "select", label: "L_BSOP_CLSF_NM", area: "comnCd", comnCd: "COM0024"},
        inexTpCd : {type : "select", label : "L_INEX_TP_CD", area : "comnCd", comnCd: "CGM0176"},
        notiId : {type: "text", label : "L_NOTI_ID"},
        notiNm : {type: "text", label : "L_NOTI_NM"},
        notiSendStatCd: { type: "select", label: "L_NOTI_SEND_STAT", area: "comnCd", comnCd: "PTL0022" },
        notiTpValue : {type: "select", label : "L_NOTI_TP", 
            options:
            [
                { label: "SMS", value: "1" },
                { label: "E-Mail", value: "2" },
                { label: "Push Notification", value: "4" },
            ]
        },

        usrNm : {type: "text", label :"L_USR_NM"},
        usrEmlAddr : {type: "text", label :"L_USR_EML_ADDR"},
        usrMoblNo : {type: "text", label :"L_USR_MOBL_NO"},
        sndrNm : {type: "text", label :"L_SNDR_NM"},
        sndrEmlAddr : {type: "text", label :"L_SNDR_EML_ADDR"},
        sndrTelno : {type: "text", label :"L_SNDR_TELNO"},
        notiMsgCn : {type: "textarea", label :"L_NOTI_MSG_CN"},



        svrCd: { type: "text", label: "L_SVR_CD", edit: false },
        svrNm: { type: "text", label: "L_SVR_NM", edit: false },
        svrIp: { type: "text", label: "L_SVR_IP", edit: false },
        svrPort: { type: "text", label: "L_SVR_PORT", edit: false },
        cnctId: { type: "text", label: "L_CNCT_ID", edit: false },
        cnctPw: { type: "text", label: "L_CNCT_PW", edit: false },
        ordNo: { type: "text", label: "L_ORD_NO", edit: false },
        cnctFailCnt: { type: "text", label: "L_CNCT_FAIL_CNT", edit: false },
        svrDtlInfo: { type: "text", label: "L_SVR_DTL_INFO", edit: false },
    },
};


interface SettingsMap {
    [key: number]: string;
}


export const SETTINGS_MAP: SettingsMap = {
    1: "SMS",
    2: "E-Mail",
    4: "Push Notification", // 예시로 추가된 설정
    // 필요에 따라 여기에 더 많은 설정을 추가할 수 있습니다.
};
